module.exports = __webpack_public_path__ + "img/header_mob@2x.ff95337.jpg";